import sample from 'lodash/sample';

export const CHAIN_ID = 421613;
export const NODES = {
  56: ['https://bsc-dataseed.binance.org', 'https://bsc-dataseed1.defibit.io'],

  421613: [
    'https://rpc.buildbear.io/many-ric-olie-77c2a995',
    'https://arbitrum-goerli.publicnode.com',
    'https://endpoints.omniatech.io/v1/arbitrum/goerli/public',
  ],
};

export default function getNodeUrl() {
  const nodeUrl = sample(NODES[CHAIN_ID]);
  if (nodeUrl === undefined) {
    return NODES[CHAIN_ID][0];
  }
  return nodeUrl;
};

//export default getNodeUrl;
